import Box from '@mui/material/Box';
import AppCard from 'main/core/AppCard';
import PropTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';
import ProductGraph from './ProductGraph';

const ProductQuantity = (props) => {
  const {productData} = props;

  return (
    <AppCard title='Product Overview' sxStyle={{height: 1}}>
      <ProductGraph productData={productData} />

      <Box
        sx={{
          mb: 1,
          mx: {xs: -2, xl: -3},
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {productData.map((item, i) => {
          return (
            <Box
              sx={{
                px: {xs: 2, xl: 3},
              }}
              key={i}
            >
              <Box
                component='h4'
                sx={{
                  mb: 1,
                  fontWeight: Fonts.MEDIUM,
                  fontSize: 18,
                  color: item.color,
                }}
              >
                {item.quantity}
              </Box>
              <Box
                sx={{
                  position: 'relative',
                }}
              >
                <Box
                  component='p'
                  sx={{
                    color: 'text.primary',
                    fontSize: 14,
                    textTransform: 'capitalize',
                  }}
                >
                  {item.name}
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </AppCard>
  );
};

export default ProductQuantity;

ProductQuantity.defaultProps = {
  productData: [],
};

ProductQuantity.propTypes = {
  productData: PropTypes.array,
};
